import { deviceIdAtom } from '@states/deviceAtoms';
import { getDeviceId } from '@utils/nativeUtils';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

import useNativeListener from './useNativeListener';

function useDeviceId() {
    const [deviceId, setDeviceId] = useAtom(deviceIdAtom);

    useNativeListener('getDeviceId', (id?: string) => {
        if (id) {
            setDeviceId(id);
        }
    });

    useEffect(() => {
        getDeviceId();
    }, []);

    return deviceId;
}

export default useDeviceId;
